/**
 * Отсчёт времени цифрами: «05:23», «1:05:23».
 *
 * Ведущий ноль у минут всегда. Без него строка меняет ширину на каждой десятой минуте («9:59»
 * против «10:00»), и всё, что стоит рядом, дёргается — а этот счётчик как раз тикает каждую
 * секунду на виду. Часы появляются только когда они есть: «1:05:23» читается как час пять, а
 * «01:05:23» заставляет пересчитывать разряды.
 *
 * До этой утилиты один и тот же отсчёт собирался четырьмя способами: «05:23» в оверлее звонка,
 * «5:23» в карточке того же звонка в переписке, «5:23»/«1:05:23» в голосовой комнате и «04:37»
 * в счётчике «осталось играть». Первые два стояли на расстоянии одного клика друг от друга.
 *
 * Секунды на входе, а не миллисекунды: у всех вызывающих под рукой именно секунды, а перевод
 * туда-обратно — лишний повод ошибиться на три нуля.
 */
export const formatElapsed = (totalSeconds: number): string => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;

  const mmss = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  return hours > 0 ? `${hours}:${mmss}` : mmss;
};
